import { Coupon } from '@core/models/swagger';
import { createAction, props } from '@ngrx/store';

export enum ProjectActions {
  ResetQuickQuote = '[Quick Quote] Reset quick quote',
  UpdateQuickQuote = '[Quick Quote] Update quick quote',
}

export const ResetQuickQuote = createAction(ProjectActions.ResetQuickQuote);

export const UpdateQuickQuote = createAction(ProjectActions.UpdateQuickQuote, props<{ data: any }>());
